import React from "react"
import Helmet from "react-helmet"
import Board from "../components/board.js"
import Link from "gatsby-link"
import styles from "../styles/index.module.scss"
import banner1 from "../../images/bnr1.jpg"
import banner2 from "../../images/bnr2.jpg"
import topPic from "../../images/ted.jpg"
const disableForm = true;

export default ({data}) =>
  <div>
	<Helmet
	  title={data.site.siteMetadata.title}
	/>
    <h1 className={styles.title}>{data.site.siteMetadata.title}</h1>
    	<section className={styles.banners}>
    		<a href="https://docs.google.com/forms/d/e/1FAIpQLSfEpv3de6uwkQ-n0BW7HWrSh-71b-ztWqefCGDRM4qXAaUpWw/viewform"
    			target="__blank">
    			<img src={banner1} className={styles.banner} />
    		</a>
    	</section>
    	<section>
	    	<Board>
	    		<div style={{marginBottom: "-10px"}}>
	    			<div style={{float:"left", marginLeft:"1rem"}}>
	    				{
							( () => {
								if (disableForm) {
									return <div style={{backgroundColor:"yellow", padding:"0.3rem 1rem", marginBottom:0}}><b>終了</b></div>
								} else {
									return <p style={{fontSize:"1rem", marginBottom:0}}>Next>></p>
								}
							} )()
						}
	    			</div>
	    			<div style={{float:"right", marginRight:"1rem"}}>
				    <Link to="/archives/視聴会/">
				    	<p　className={styles.tags}>#視聴会</p>
				    </Link>
	    			</div>
	    		</div>
	    		<br style={{clear:"both"}}/>
			    
				{/* todo: import infomation from data / set tags */}
			    <div className={styles.nextInfo}>
				    <h3 className={styles.topic}>Vol.2　TED Talks 視聴会</h3>
				    <img src={topPic} />
				    <blockquote>
				    	バーの一角でプロジェクターを使いTED Talksのアーカイブを視聴します。<br/>
				    	参加費は無料、いつ来ていつ帰ってもOKです。<br/>
				    	※バーのチャージ料金(500円)＋ご自身のドリンク代がかかります。
				    </blockquote>
				    <h4>いまのところ観たいと思っているもの</h4>
				    <ul>
					    <li>サム・ハリス： 道徳観にまつわる科学</li>
					    <li>サム・ハリス： 人間より優れた人工知能を作って制御を失わずにいることは可能か？</li>
					    <li>マイケルシャーマー: 不思議なものを信じる</li>
				    </ul>
				    <p>他にも現地で意見を聞いて皆の興味のあるものを再生したいと思います。</p>

				    <h4　className={styles.sectionTitle}>日時</h4>
				    <p>2017/12/13 (水)　20:30 ~ 大体0:00くらい</p>
				    
				    <h4　className={styles.sectionTitle}>会場</h4>
			    	<p>
			    		UNDER BAR<br/>
			    		札幌市中央区南5条西2丁目8-9社交会館 5階<br/>
			    		<a href="http://wavs.jp/?project=underbar" target="__blank">http://wavs.jp/?project=underbar</a>
			    	</p>
				    
				    <h4　className={styles.sectionTitle}>料金</h4>
				    <p>バーのチャージ料金500円＋ご自身のドリンク代（500円～）</p>
				    
				    <form name="reserve" netlify-honeypot="bot-field" action="thank-you" data-netlify="true" style={{overflow:"hidden", display:"none"}}>
				    	<h4>申込み</h4>
				      <p>参加は事前予約制となります。<br />
				      下記の注意事項をお読みいただいた上で、こちらからお申し込みください。<br />
				      なお定員10名程度を予定しています。</p>
					  <p style={{display: "none"}}>
					    <label>Don’t fill this out: <input name="bot-field" /></label>
					  </p>
					  <p>※申し込み受付完了後に確認メールをお送りさせていただきます。メールが届かない場合はお手数ですが再度メールアドレスを確認の上送信、または<Link to="/contact">Contact</Link>の連絡先までお問い合わせください。</p>
					  <p>
					    <label>　　　ご予約名:　<input type="text" name="name" className={styles.textField} disabled={disableForm} /></label>
					  </p>
					  <p>
					    <label>　　　　　人数:　
					    <select size="1" name="count" className={styles.listBox} disabled={disableForm} >
						<option value="1">1</option><option value="2">2</option><option value="3">3</option>
						<option value="4">4</option><option value="5">5</option><option value="6">6</option>
						<option value="7">7</option><option value="8">8</option><option value="9">9</option>
						</select></label>
					  </p>
					  <p>
					    <label>メールアドレス:　<input type="text" name="mail"  className={styles.textField} disabled={disableForm} /></label>
					  </p>
					  <label>　　　　　　　　　<input type="checkbox" name="receiveNotification" disabled={disableForm} />　今後の開催情報をメールで受け取る</label>
					  <p>
					    <button type="submit">送信</button>
					  </p>
					</form>

				    <aside style={{display:"none"}}>
					    <h4>注意事項</h4>
					    	<ul>
					    		<li>当日会場内は禁煙とさせていただきます。ご協力のほどよろしくお願い致します。</li>
					    		<li>当日イベントの模様は動画で撮影し、後日配信させていただく予定です。不都合のある方がいらっしゃいましたらお声かけください。</li>
					    	</ul>
				    </aside>
				</div>
			</Board>
		</section>
	</div>


export const query = graphql`
  query indexQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/index.js